<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" title="The Big Book of Gross Stuff">
<div class="recto">
<h1><a id="id1527026">The Big Book of Gross Stuff</a></h1><a id="id1527026">
<h3>Bart King</h3>
<img alt="Gibbs Smith Logo" src="images/logo.png"/>
</a></div><a id="id1527026">
</a></div><a id="id1527026">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// recto.vue?08b4231e